import ajaxQueue from './lib/ajaxQueue';
import { checkIsFormValid } from 'ca-assets/javascripts/validation-helpers';
import React from 'react';
import { createRoot } from 'react-dom/client';

/*
a[data-modal=URL]     Fetches URL with Ajax and displays response as modal
                      content.
form[data-modal=URL]  Attempt to submit loads URL with Ajax and displays
                      response as modal content (e.g. confirmation prompt).

#overlay              Covers page content with translucency.
#modal                Container for modal content.
  form                Submit sets #modal[data-form-changes=false].
    :input            Changes set #modal[data-form-changes=true].
  form.modal--ignore-changes
    :input            Changes DO NOT set #modal[data-form-changes=true].
  a.submit-from-modal Submits form[data-modal] in underlying page that
                      previously triggered this modal.
  .close, .done       Click closes modal (with confirmation prompt if
                      #modal[data-form-changes=true]).
*/

$(() => {
  const $modal = (window.$modal = $('#modal'));
  const $overlay = $('#overlay');
  const $body = $(document.body);
  let $form;
  let root;

  const $document = $(document);

  $modal.on('change', 'form:not(.modal--ignore-changes) :input', () => {
    $modal.data('form-changes', 'true');
  });

  $modal.on('submit', 'form', () => {
    $modal.data('form-changes', 'false');
  });

  $document.on('click', 'a[data-modal]', (event) => {
    event.preventDefault();
    fetch(event, 'a');
  });

  $document.on('click', 'button[data-modal]', (event) => {
    event.preventDefault();
    fetch(event, 'button');
  });

  $document.on('submit', 'form[data-modal]', (event) => {
    event.preventDefault();
    $form = $(event.currentTarget);
    if (!$form.hasClass('validate') || checkIsFormValid($form)) {
      ajaxFetch({ url: $form.attr('data-modal'), data: $form.serialize() });
    }
  });

  $document.on('click', 'a.submit-from-modal', (event) => {
    event.preventDefault();
    $('body').css('cursor', 'progress');
    $form.removeAttr('data-modal');
    $form.removeAttr('onsubmit').submit();
    close();
  });

  if (ie && BrowserDetect.version < 9) {
    $overlay.on('click', (event) => {
      if (event.target.id === 'modal' || event.target.id === 'overlay') {
        close();
      }
    });
  }

  $modal.on('click', (event) => {
    const $el = $(event.target);
    if ($el.closest('#modal .close, #modal .done').length) {
      event.preventDefault();
      if ($body.hasClass('modal-active')) {
        close();
      }
    }
    if (event.target.id === 'modal') {
      close();
    }
  });

  $document.on('keyup', (event) => {
    if (event.keyCode === 27) {
      close();
    }
  });

  $(window).on('modal:end', () => {
    $modal.data('form-changes', 'false');
    $body.addClass('modal-active');
    if ($modal.find('[autofocus]').length > 0) {
      $modal.find('[autofocus]').focus();
    }
  });

  $(window).on('modal:close', () => {
    close();
  });

  function ajaxFetch(opts) {
    $(window).trigger('modal:start');
    ajaxQueue({
      url: opts.url,
      type: 'GET',
      dataType: 'html',
      data: opts.data,
      success: (content) => {
        window.$ = $; // content loaded with .html() may contain JavaScript that expects global $
        $modal.html(content);
        $(window).trigger('modal:end');
        // only target the DemographicsModalApp, this prevents re-rendering the entire page.
        $(window).trigger('react-automount', 'DemographicsModalApp');
      },
      error: (jqXHR) => {
        if (jqXHR.status === 403) {
          /* eslint-disable no-alert */
          alert('You do not have permission to access this resource');
        } else {
          /* eslint-disable no-alert */
          alert(
            "There was an error loading this resource. Please check your Internet connection and try again. If you're still having trouble, drop us a line at support@cultureamp.com"
          );
        }
      },
    });
  }

  function fetch(event, tag) {
    const $el = $(event.target).closest(tag);

    if ($el.data('newApp')) {
      $modal.html("<div class='card--modal medium'><div/></div>");
      const ComponentType = $el.data('newApp');
      const props = $el.data('newProps');
      const element = <ComponentType {...props} />;

      root = createRoot($modal.find('.card--modal >div').get(0));
      root.render(element);
      $(window).trigger('modal:end');
    } else {
      confirmSaved($el.data('force'), () => {
        ajaxFetch({ url: $el.data('modal') });
      });
    }
  }

  function close(force) {
    confirmSaved(force, () => {
      $body.removeClass('modal-active');
      const reactRoot = $modal.find('.card--modal >div').get(0);
      if (reactRoot && root) root.unmount();
      $modal.empty();
      $modal.data('form-changes', 'false');
    });
    return false;
  }

  function confirmSaved(force, callback) {
    if (!force && $modal.data('form-changes') === 'true') {
      if (!confirm('Continue without submitting your changes?')) {
        return;
      }
    }
    callback();
  }
});
